export default __webpack_public_path__ + "static/media/distributors-banner.de703d70.jpg";